module.exports = __webpack_public_path__ + "img/logob.19364cd7.png";